module.exports = __webpack_public_path__ + "media/images/Moins-1-db8a4ef18ca955fff2bfee0fe1af648e.svg";